/* Kloopp — agregar al carrito sin recargar y contador del header.
   Si JS falla, los formularios funcionan igual (envían a /cart/add y redirigen al carrito). */
(function () {
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('[data-ajax-add]')) return;

    /* "Comprar ahora" (name="return_to") envía el formulario normal y va al checkout */
    if (event.submitter && event.submitter.name === 'return_to') return;
    event.preventDefault();

    var button = event.submitter || form.querySelector('[type="submit"]');
    var label = button ? button.textContent : '';
    if (button) button.disabled = true;

    fetch(form.action.replace(/\/?$/, '') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch('/cart.js').then(function (c) {
          return c.json();
        });
      })
      .then(function (cart) {
        setCount(cart.item_count);
        if (button) button.textContent = 'Agregado ✓';
      })
      .catch(function () {
        form.removeAttribute('data-ajax-add');
        form.submit();
      })
      .finally(function () {
        if (button) {
          setTimeout(function () {
            button.textContent = label;
            button.disabled = false;
          }, 1500);
        }
      });
  });
})();

/* Kloopp — animación de aparición al hacer scroll. El head agrega "kl-js" solo si el navegador
   la soporta y la persona no pidió menos movimiento; sin eso todo se ve de inmediato. */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('kl-js')) return;

  var items = [];
  document.querySelectorAll('[data-reveal]').forEach(function (el) {
    items.push(el);
  });
  document.querySelectorAll('[data-reveal-group]').forEach(function (group) {
    Array.prototype.forEach.call(group.children, function (el, index) {
      el.style.setProperty('--i', index % 6);
      items.push(el);
    });
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        /* Lo que quedó por encima de la pantalla (recarga con scroll o salto) se muestra de inmediato */
        if (!entry.isIntersecting && entry.boundingClientRect.top >= 0) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    },
    /* threshold 0: en elementos muy altos (políticas) un porcentaje podría no alcanzarse nunca */
    { rootMargin: '0px 0px -8% 0px', threshold: 0 }
  );
  items.forEach(function (el) {
    observer.observe(el);
  });
  root.classList.add('kl-ready');
})();
